class SearchService {
   appState: AppStateService
   events: EventService
   constructor(appState: AppStateService, events: EventService) {
      this.appState = appState
      this.events = events
   }

   runSearch(search: any, view: any) {
      const { query } = search

      const setState = () => {
         const { params } = this.appState

         delete params.sort
         delete params.exp
         delete params.ru
         delete params.edym

         if (query !== "") {
            delete params.bookMark
         }

         params.q = query
         params.pn = 1
         return params
      }

      this.appState.applyStateWithSnapShot(setState)
      this.events.publish('actions', 'searchbox:query', { source: view, terms: query })
      return this.events.gaPush('search', 'new', query)
   }

}

SearchService.$inject = ['appStateService', 'eventService']

angular.module('summonApp.services')
   .service('searchService', SearchService)
